import { createContext } from "react";
const PresenceContext = createContext(null);
export {
  PresenceContext
};
//# sourceMappingURL=PresenceContext.js.map
